/* === MALĀKITE JEWELLERY — THEME JS === */

function openDrawer() {
  document.getElementById('drawer').classList.add('open');
  document.getElementById('drawerOverlay').classList.add('active');
  document.body.style.overflow = 'hidden';
}
function closeDrawer() {
  document.getElementById('drawer').classList.remove('open');
  document.getElementById('drawerOverlay').classList.remove('active');
  document.body.style.overflow = '';
}

function showCartNotification(title) {
  var existing = document.getElementById('cart-notification');
  if (existing) existing.remove();
  var el = document.createElement('div');
  el.id = 'cart-notification';
  el.innerHTML =
    '<div style="display:flex;align-items:center;gap:12px;">' +
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>' +
    '<div><p style="font-size:10px;letter-spacing:2px;text-transform:uppercase;color:#c9a96e;font-weight:600;margin-bottom:2px;">Added to Cart</p>' +
    '<p style="font-size:12px;color:#e8d9b5;">' + title + '</p></div>' +
    '<a href="/cart" style="margin-left:auto;background:#c9a96e;color:#1b3a2d;padding:8px 16px;font-size:10px;letter-spacing:1.5px;text-transform:uppercase;font-weight:700;white-space:nowrap;text-decoration:none;">View Cart</a>' +
    '</div>';
  el.style.cssText='position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#1b3a2d;padding:16px 20px;z-index:9999;min-width:320px;max-width:92vw;border-left:3px solid #c9a96e;font-family:Montserrat,Arial,sans-serif;';
  document.body.appendChild(el);
  setTimeout(function(){el.style.transition='opacity .4s';el.style.opacity='0';setTimeout(function(){el.remove();},400);},3500);
}

function refreshCartCount() {
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var badge=document.querySelector('.cart-count');
    if(cart.item_count>0){
      if(!badge){badge=document.createElement('span');badge.className='cart-count';var b=document.querySelector('.cart-btn');if(b)b.appendChild(badge);}
      badge.textContent=cart.item_count;
    } else if(badge){badge.remove();}
  });
}

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.product-quick-add').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();
      var id=btn.dataset.id;if(!id)return;
      var orig=btn.textContent;
      btn.textContent='Adding...';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(id),quantity:1})})
      .then(function(r){if(!r.ok)throw new Error('fail');return r.json();})
      .then(function(item){
        btn.textContent='Added!';
        showCartNotification(item.title||'Item');
        refreshCartCount();
        setTimeout(function(){btn.textContent=orig;},2000);
      })
      .catch(function(){btn.textContent='Error';setTimeout(function(){btn.textContent=orig;},2000);});
    });
  });

  window.addEventListener('scroll',function(){
    var h=document.querySelector('.header');
    if(h)h.style.boxShadow=window.scrollY>30?'0 2px 14px rgba(0,0,0,0.07)':'';
  });
});

/* CARD VARIANT CHANGE — updates price + button variant id */
function cardVariantChange(select, productId) {
  var opt = select.options[select.selectedIndex];
  var price = opt.dataset.price;
  var variantId = select.value;

  var priceEl = document.getElementById('price-' + productId);
  if (priceEl && price) priceEl.textContent = price;

  var btn = document.getElementById('atc-btn-' + productId);
  if (btn) {
    btn.dataset.id = variantId;
    if (opt.disabled) {
      btn.textContent = 'Sold Out';
      btn.disabled = true;
      btn.classList.add('card-atc-btn--soldout');
    } else {
      btn.textContent = 'Add to Cart';
      btn.disabled = false;
      btn.classList.remove('card-atc-btn--soldout');
    }
  }
}

/* CARD ADD TO CART */
function cardAddToCart(btn) {
  var id = parseInt(btn.dataset.id);
  if (!id || btn.disabled) return;
  var orig = btn.textContent;
  btn.textContent = 'Adding...';
  btn.classList.add('card-atc-btn--loading');
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: id, quantity: 1 })
  })
  .then(function(r) { if (!r.ok) throw new Error('fail'); return r.json(); })
  .then(function(item) {
    btn.textContent = '✓ Added';
    btn.classList.remove('card-atc-btn--loading');
    btn.classList.add('card-atc-btn--done');
    showCartNotification(item.title || 'Item');
    refreshCartCount();
    setTimeout(function() {
      btn.textContent = orig;
      btn.disabled = false;
      btn.classList.remove('card-atc-btn--done');
    }, 2200);
  })
  .catch(function() {
    btn.textContent = 'Error — try again';
    btn.classList.remove('card-atc-btn--loading');
    btn.disabled = false;
    setTimeout(function() { btn.textContent = orig; }, 2200);
  });
}
